export default __webpack_public_path__ + "81e38ac739a66247be0698c81ca44380.png";